var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "ma-0 pa-0", attrs: { fluid: "" } },
    [
      _c("Header"),
      _c(
        "v-col",
        {
          staticClass: "pa-0",
          attrs: { id: "main_content_maxwidthset", cols: "12" },
        },
        [
          _c(
            "v-row",
            { staticClass: "ma-0 pa-2 pt-9" },
            [
              _c("v-col", { attrs: { cols: "1" } }, [
                _vm._v(" " + _vm._s("contractCd") + " "),
              ]),
              _c("v-col", { attrs: { cols: "4" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.contractCd,
                      expression: "contractCd",
                    },
                  ],
                  attrs: { id: "input_grey", placeholder: "contractCd" },
                  domProps: { value: _vm.contractCd },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.contractCd = $event.target.value
                    },
                  },
                }),
              ]),
              _c("v-col", { attrs: { cols: "1" } }, [
                _vm._v(" " + _vm._s("portNo") + " "),
              ]),
              _c("v-col", { attrs: { cols: "4" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.portNo,
                      expression: "portNo",
                    },
                  ],
                  attrs: { id: "input_grey", placeholder: "portNo" },
                  domProps: { value: _vm.portNo },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.portNo = $event.target.value
                    },
                  },
                }),
              ]),
              _vm.isClick
                ? _c(
                    "v-col",
                    { attrs: { cols: "2" } },
                    [
                      _c("v-switch", {
                        staticClass: "ma-0 pa-0",
                        attrs: {
                          label: _vm.isMuted ? "Unmute" : "Mute",
                          inset: "",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "label",
                              fn: function () {
                                return [
                                  _c(
                                    "span",
                                    { staticStyle: { color: "white" } },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.isMuted ? "Unmute" : "Mute")
                                      ),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          3711956541
                        ),
                        model: {
                          value: _vm.isMuted,
                          callback: function ($$v) {
                            _vm.isMuted = $$v
                          },
                          expression: "isMuted",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.isClick
                ? _c(
                    "v-col",
                    { attrs: { cols: "2" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            width: "100%",
                            height: "2.5rem",
                            id: "blue_btn",
                          },
                          on: { click: _vm.complete },
                        },
                        [_vm._v(" " + _vm._s("start") + " ")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "v-row",
            { staticClass: "ma-0 pa-2 pt-9" },
            [
              _c("v-col", { staticClass: "ma-0 pa-0", attrs: { cols: "12" } }, [
                _c("video", {
                  ref: "videoElement",
                  staticClass:
                    "video-js vjs-default-skin vjs-big-play-centered vjs-current-time",
                  attrs: { id: "myVideo", controls: "", autoplay: "" },
                }),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }